module.exports = "<div class=\"header\">\r\n    <h1>New York State Water Quality</h1>\r\n</div>\r\n"